<template>
    <div id="nav" ref="nav" class="wrapper--nav" @keydown.esc="closeMenu" tabindex="-1">        
        <transition name="slide-menu" @after-enter="focusMenu" @after-leave="focusBtn">

            <MenuArea 
                aria-labelledby="mainMenuBtn"
                :class="['slide__text-el', {
                    '-open': menuOpened,
                    '-submenu': submenuOpened
                }]" 
                @close="toggleMenu" 
                v-bind="{
                    mainLinks,
                    menuLinks,
                }"
                v-if="menuOpened" 
            />

        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { focusables } from '@/mixins/focusables'
import MenuArea from './MenuArea'

import { MAIN_MENU_LINKS } from '@/data/pages'
const q = s => document.querySelector(s)

export default {
    components: {
        MenuArea,
    },
    computed: {
        mainLinks() {
            return MAIN_MENU_LINKS
        },
        ...mapState({
            menuLinks: state => state.menu.items,
            menuOpened: state => state.menu.opened,
            submenuOpened: state => state.menu.submenu,
        }),
    },
    created() {
        this.$root.$on('toggle-menu', () => {
            this.toggleMenu()
        })
    },
    beforeDestroy() {
        this.$root.$off('toggle-menu')
    },
    data: () => ({
        activeEl: null,
    }),
    mixins: [
        focusables,
    ],
    methods: {
        focusMenu() {
            const focusableTitle = this.$refs.nav.querySelector('.main-menu__nav-item')
            focusableTitle.focus() 
        },
        focusBtn() {
            this.$refs.nav.parentNode.querySelector('#mainMenuBtn').focus()
        },
        closeMenu() {
            if ( this.submenuOpened ) {
                this.$store.commit('setSubmenuOpened', false)
                this.activeEl && this.activeEl.focus()
                return;
            }
            this.toggleMenu()
        },
        toggleMenu() {
            this.$store.commit('setMenuOpened', !this.menuOpened ? true : false)

            const innerPage = q('.wrapper--page')
            const page = innerPage || q('.wrapper--slides') || q('.story')
            
            const buttons = q('.wrapper--logo')
            const headerButtons = q('.wrapper--corner-buttons')
            
            const wrapperSlides = q('.wrapper--slides')
            const currentSlide = q('.slide.is-active')
            const arrowButtons = q('.slide__arrows')

            if ( !this.menuOpened ) {
                this.$store.commit('setSubmenuOpened', false)
                this.focusables()
                    .add( page )
                    .add( buttons )
                    .add( headerButtons )
                    .rm( wrapperSlides )
                    .add( currentSlide )
                    .add ( arrowButtons )
            }
            else {
                this.focusables()
                    .rm( page )
                    .rm( buttons )
                    .rm( headerButtons )
                
            }
            if ( this.isMobile() ) {
                this.rootClass(!this.menuOpened ? 'rm' : 'add')
            }
        },
    },
}
</script>